import { Surface } from '@dx-ui/global-ui-prism';
import { DrawerPanel } from '@dx-ui/osc-drawer';
import type { PropsWithChildren } from 'react';
import cx from 'classnames';
import { useHeaderContext } from '../../context/header-context';
import { useHeaderStateContext } from '../../context/header-state-context';

type MobileMenuDrawerProps = PropsWithChildren<{
  className?: string;
}>;

export const MobileMenuDrawer = ({ children, className }: MobileMenuDrawerProps) => {
  const {
    visual: { surfaceType, isTranslucent },
    accessibility: { wrapperId },
  } = useHeaderContext();

  const {
    menuState: { isMenuOpen },
    displayFlags: { isMenuItemsAvailable, isGlobalNavAvailable },
  } = useHeaderStateContext();

  if (!(isMenuItemsAvailable || isGlobalNavAvailable)) return null;

  return (
    <div data-testid="menuWindow" className={cx({ visible: isMenuOpen, invisible: !isMenuOpen })}>
      <Surface type={surfaceType}>
        <DrawerPanel
          isOpen={isMenuOpen}
          alignment="left"
          appWrapperId={wrapperId}
          interactiveElementWrapperId="drawer-nav"
          returnFocus={() => {
            document.getElementById('menu-open-button')?.focus();
            return false;
          }}
          className={cx('osc-nav-drawer', className, {
            '!bg-translucent bg-blur': isTranslucent,
          })}
        >
          {children}
        </DrawerPanel>
      </Surface>
    </div>
  );
};
